import { types } from 'mobx-state-tree';

export const QAStore = types.model('QAStore', {});
// .views(self => ({}))
// .actions(self => ({}));
